RivalIQ.apps.CompanyProfile.module('views', function (views, App, Backbone, Marionette, $, _, formatter) {

    'use strict';

    views.DemographicsBreakdown = Marionette.LayoutView.extend({
        className: 'modal fade',

        attributes: {
            tabindex: -1
        },

        regions: {
            modalBodyRegion: '.modal-body',
            pieChartRegion: '.x-demographic-piechart',
            table: '.x-demographic-table'
        },

        ui: {
            noDemoDataMsg: '.x-no-demo-data-msg',
            mainContent: '.x-demographic-content'
        },

        events: {
            'show.bs.modal': 'onModalShow',
            'shown.bs.modal': 'onModalShown'
        },

        template: '#overviewDemographicsBreakdownModalTemplate',

        templateHelpers: function () {

            const me = this;

            return {
                title: me.getOption('title')
            };
        },

        initialize: function (options) {

            const me = this;
            const companyId = options.companyId;
            const companyData = me.companyData = options.companyData;
            const locationType = me.locationType = options.locationType;
            const demographicType = me.demographicType = options.demographicType;
            const companyModel = companyData.get(companyId);
            me.colorFun = options.colorFun;

            me.source = options.source || RivalIQ.data.CompareData.sources.FACEBOOK;
            if (me.source === RivalIQ.data.CompareData.sources.FACEBOOK_INSIGHTS) {
                me.demographics = RivalIQ.utils.companyDisplay.getFacebookDemographics(companyModel.toJSON(), locationType, demographicType);

                switch (options.demographicType) {
                    case 'fans-by-age-gender':
                        me.tableColumnNames = [
                            RivalIQ.strings.facebook_insights_demographics_columns_gender,
                            RivalIQ.strings.facebook_insights_demographics_columns_fans,
                            RivalIQ.strings.facebook_insights_demographics_columns_fans_percent
                        ];
                        break;
                    case 'reach-by-age-gender':
                        me.tableColumnNames = [
                            RivalIQ.strings.facebook_insights_demographics_columns_gender,
                            RivalIQ.strings.facebook_insights_demographics_columns_avg_reach,
                            RivalIQ.strings.facebook_insights_demographics_columns_avg_reach_percent
                        ];
                        break;
                    case 'fans-by-country':
                        me.tableColumnNames = [
                            RivalIQ.strings.facebook_insights_demographics_columns_country,
                            RivalIQ.strings.facebook_insights_demographics_columns_fans,
                            RivalIQ.strings.facebook_insights_demographics_columns_fans_percent
                        ];
                        break;
                    case 'fans-by-city':
                        me.tableColumnNames = [
                            RivalIQ.strings.facebook_insights_demographics_columns_city,
                            RivalIQ.strings.facebook_insights_demographics_columns_fans,
                            RivalIQ.strings.facebook_insights_demographics_columns_fans_percent
                        ];
                        break;
                    case 'reach-by-country':
                        me.tableColumnNames = [
                            RivalIQ.strings.facebook_insights_demographics_columns_country,
                            RivalIQ.strings.facebook_insights_demographics_columns_avg_reach,
                            RivalIQ.strings.facebook_insights_demographics_columns_avg_reach_percent
                        ];
                        break;
                    case 'reach-by-city':
                        me.tableColumnNames = [
                            RivalIQ.strings.facebook_insights_demographics_columns_city,
                            RivalIQ.strings.facebook_insights_demographics_columns_avg_reach,
                            RivalIQ.strings.facebook_insights_demographics_columns_avg_reach_percent
                        ];
                        break;
                    default:
                        throw new Error(`unknown demographic breakdown ${options.demographicType}`);
                }
            } else if (me.source === RivalIQ.data.CompareData.sources.FACEBOOK) {
                me.demographics = RivalIQ.utils.companyDisplay.getFacebookDemographics(companyModel.toJSON(), locationType, demographicType);
                me.tableColumnNames = [
                    RivalIQ.strings.facebook_insights_demographics_columns_country,
                    RivalIQ.strings.facebook_insights_demographics_columns_fans,
                    RivalIQ.strings.facebook_insights_demographics_columns_fans_percent
                ];
            } else if (me.source === RivalIQ.data.CompareData.sources.LINKEDIN) {
                me.demographics = RivalIQ.utils.companyDisplay.getLinkedInDemographics(companyModel.toJSON(), demographicType);
                switch (demographicType) {
                    case 'country':
                        me.tableColumnNames = [
                            'Country',
                            RivalIQ.strings.linked_in_demographics_columns_followers,
                            RivalIQ.strings.linked_in_demographics_columns_followers_percent
                        ];
                        break;

                    case 'city':
                        me.tableColumnNames = [
                            'Region',
                            RivalIQ.strings.linked_in_demographics_columns_followers,
                            RivalIQ.strings.linked_in_demographics_columns_followers_percent
                        ];
                        break;

                    case 'industry':
                        me.tableColumnNames = [
                            'Industry',
                            RivalIQ.strings.linked_in_demographics_columns_followers,
                            RivalIQ.strings.linked_in_demographics_columns_followers_percent
                        ];
                        break;

                    case 'job-function':
                        me.tableColumnNames = [
                            'Job Function',
                            RivalIQ.strings.linked_in_demographics_columns_followers,
                            RivalIQ.strings.linked_in_demographics_columns_followers_percent
                        ];
                        break;

                    default:
                        me.tableColumnNames = [
                            demographicType,
                            RivalIQ.strings.linked_in_demographics_columns_followers,
                            RivalIQ.strings.linked_in_demographics_columns_followers_percent
                        ];
                        break;
                }
            } else if (me.source === RivalIQ.data.CompareData.sources.INSTAGRAM_INSIGHTS) {
                me.demographics = RivalIQ.utils.companyDisplay.getInstaDemographics(companyModel.toJSON(), demographicType);
                switch (demographicType) {
                    case 'country':
                        me.tableColumnNames = [
                            RivalIQ.strings.facebook_insights_demographics_columns_country,
                            RivalIQ.strings.instagram_insights_audience_gender_age_name,
                            RivalIQ.strings.instagram_insights_audience_gender_age_percentage
                        ];
                        break;
                    case 'city':
                        me.tableColumnNames = [
                            RivalIQ.strings.facebook_insights_demographics_columns_city,
                            RivalIQ.strings.instagram_insights_audience_gender_age_name,
                            RivalIQ.strings.instagram_insights_audience_gender_age_percentage
                        ];
                        break;
                    case 'gender_age':
                        me.tableColumnNames = [
                            RivalIQ.strings.instagram_insights_demographics_age_gender_columns_gender,
                            RivalIQ.strings.instagram_insights_audience_gender_age_name,
                            RivalIQ.strings.instagram_insights_audience_gender_age_percentage
                        ];
                        break;
                    default:
                        throw new Error(`unknown demographic breakdown ${demographicType}`);
                }
            }

            _.bindAll(me, 'renderColorBox');
            _.bindAll(me, 'getCountPercentage');
        },

        onBeforeShow: function () {

            const me = this;
            const demographics = me.demographics;

            if (!me.hasAccess(me.source)) {

                return me.modalBodyRegion.showChannelWall(me.source, 'large');
            }

            if (!_.size(demographics)) {

                me.ui.noDemoDataMsg.removeClass('hide');
                me.ui.mainContent.addClass('hide');
            }
        },

        onModalShow: function () {

            const me = this;
            const demographics = me.demographics;

            if (me.source === RivalIQ.data.CompareData.sources.FACEBOOK) {
                RivalIQ.execute('tracking:push:auth', RivalIQ.tracking.metric.ViewedFacebookGeographicData);
            }

            if (me.hasAccess(me.source) && _.size(demographics)) {

                me.renderPieChart();
                me.renderTable();
            }
        },

        onModalShown: function () {

            $(window).resize();
        },

        renderPieChart: function () {

            const me = this;
            const demographics = _.toPairs(me.demographics);
            const tooltipTemplate = Marionette.TemplateCache.get('#pieChartTooltip');

            // NOTE if 'other' exists, it is forced to the end of the array
            const data = demographics.sort(function (a, b) {
                if (b[0] === 'other') {
                    return -1;
                }
                return b[1] - a[1];
            });

            me.pieChart = new RivalIQ.graph.Donut({
                data: data,
                dataProperty: 'demographics',
                shouldAddRemainder: true,
                rotation: 0,
                margin: {},
                minWidth: 400,
                height: 375,
                graphOptions: {
                    tooltipContent: function (slice, color) {
                        const value = slice.data[1];

                        return tooltipTemplate({
                            className: null,
                            color: color,
                            name: me.getDemographicName({
                                demographic: slice.data[0]
                            }),
                            value: (value % 1 === 0 ? formatter.formats.integer(value) : formatter.formats.numeric(value)),
                            percentage: formatter.formats.percentAbsolute(value / me.demographicSum)
                        });
                    }
                },
                colorFun: me.colorFun
            });

            me.pieChartRegion.show(me.pieChart);

            me.demographicSum = _.sumBy(data, function (datum) {
                return datum[1];
            });
        },

        renderTable: function () {
            const me = this;

            let tableValues = _.map(me.demographics, function (v, k) {
                return {
                    demographic: k,
                    count: v
                };
            });

            // NOTE if 'other' exists, it is forced to the end of the array
            tableValues = tableValues.sort(function (a, b) {
                if (b.demographic === 'other') {
                    return -1;
                }
                return b.count - a.count;
            });

            const config = {
                columns: [
                    {
                        value: me.renderColorBox,
                        cellClassName: 'text-center'
                    },
                    {
                        name: me.tableColumnNames[0],
                        value: _.bind(me.getDemographicName, me)
                    },
                    {
                        name: me.tableColumnNames[1],
                        property: 'count',
                        formatter: formatter.formats.abbreviated,
                        className: 'text-right',
                        cellClassName: 'text-right'
                    },
                    {
                        name: me.tableColumnNames[2],
                        value: me.getCountPercentage,
                        className: 'text-right',
                        cellClassName: 'text-right'
                    }
                ]
            };

            me.table.show(new RivalIQ.views.TableContainer({
                config: config,
                model: new Backbone.Model({
                    data: tableValues
                })
            }));
        },

        getCountPercentage: function (datum) {

            const me = this;
            return formatter.formats.percentAbsolute(datum.count / me.demographicSum);
        },

        getDemographicName: function (datum) {

            const me = this;

            const demographic = (datum.demographic || '');
            if (me.source === RivalIQ.data.CompareData.sources.LINKEDIN) {
                if (_.includes(['other', 'others'], demographic.toLowerCase())) {
                    switch (me.demographicType) {
                        case 'country':
                            return RivalIQ.strings.linked_in_insights_demographics_other_countries;

                        case 'city':
                            return RivalIQ.strings.linked_in_insights_demographics_other_regions;

                        case 'industry':
                            return RivalIQ.strings.linked_in_insights_demographics_other_industries;

                        case 'job-function':
                            return RivalIQ.strings.linked_in_insights_demographics_other_job_functions;

                        default:
                            return RivalIQ.strings.linked_in_insights_demographics_others;
                    }
                }

            } else {
                if (_.includes(['other', 'others'], demographic.toLowerCase())) {
                    switch (me.locationType || me.demographicType) {
                        case 'city':
                        case 'impressions-by-city':
                        case 'fans-by-city':
                        case 'reach-by-city':
                            return RivalIQ.strings.facebook_insights_demographics_other_cities;
                        case 'country':
                        case 'impressions-by-country':
                            return RivalIQ.strings.facebook_insights_demographics_other_countries;
                        default:
                            return RivalIQ.strings.facebook_insights_demographics_other_countries;
                    }
                }
            }
            return RivalIQ.utils.countryCodes.codes[demographic] || demographic;
        },

        renderColorBox: function (datum, index) {

            const me = this;
            const color = (me.colorFun) ? me.colorFun(datum, index) : me.pieChart.color()({}, index);

            return $.tagHtml('i', {
                class: ['fa', 'fa-square'],
                style: `color: ${color};`
            });
        },

        hasAccess: function (source) {

            source = (_.isFinite(source) ? source : RivalIQ.enums.sources.FACEBOOK);
            return RivalIQ.state.landscape.channelAccess(source);
        }
    });

}, RivalIQ.formatter);
